import axios from 'axios'

export default axios.create({
    baseURL: "/",
    // withCredentials: false,
    // timeout: 1000,

    headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'application/x-www-form-urlencoded',
    }
}).interceptors.request.use(function (config) {
    config.params['csrf_token'] = window.csrf_token
    return config;
})
